export interface PricingPlan {
  name: string;
  price: string;
  tagline: string;
  features: string[];
  featured: boolean;
  href: string;
}

export const plans: PricingPlan[] = [
  {
    name: "Design",
    price: "From $499",
    tagline: "Brand & Visual Design",
    features: [
      "UI/UX Design — from $499",
      "Logo & Brand Identity — from $299",
      "Presentation / Pitch Deck — from $199",
      "Social Media Kit — from $249",
      "Dashboard & App Design — from $699",
      "2–3 revision rounds included",
      "Source files (Figma) delivered",
    ],
    featured: false,
    href: "/contact",
  },
  {
    name: "Development",
    price: "From $999",
    tagline: "Most Popular — Web & App",
    features: [
      "WordPress / CMS Site — from $999",
      "Custom React/Next.js App — from $1,999",
      "Webflow / Framer Site — from $799",
      "E-commerce Store — from $1,499",
      "Mobile App (React Native) — from $2,999",
      "API Integration & Backend",
      "SEO + Performance Optimization",
    ],
    featured: true,
    href: "/contact",
  },
  {
    name: "AI & Automation",
    price: "From $1,499",
    tagline: "Chatbots, RAG & AI Solutions",
    features: [
      "Custom AI Chatbot — from $1,499",
      "RAG Pipeline Setup — from $1,999",
      "LLM Fine-Tuning — from $2,499",
      "AI Workflow Automation — from $999",
      "Integration with existing tools",
      "Training & documentation",
      "Ongoing support available",
    ],
    featured: false,
    href: "/contact",
  },
];
